import Vue from "vue";
import Router from "vue-router";

import App from "./layouts/App.vue";

import Home from "./views/Home.vue";
import Cockpit from "./views/Cockpit.vue";
import LC from "./views/LC.vue";
import About from "./views/About.vue";
import Category from "./views/Category.vue";
import Projects from "./views/Projects.vue";
import Project from "./views/Project.vue";
import News from "./views/News.vue";
import New from "./views/New.vue";
import Contacts from "./views/Contacts.vue";
import References from "./views/ThanksLetters.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/:locale",
      name: "home",
      meta: {
        layout: App
      },
      component: Home
    },
    {
      path: "/:locale/cockpit",
      name: "cockpit",
      meta: {
        layout: App
      },
      component: Cockpit
    },
    {
      path: "/:locale/licenses-and-certificates",
      name: "licenses and certificates",
      meta: {
        layout: App
      },
      component: LC
    },
    {
      path: "/:locale/about",
      name: "about",
      meta: {
        layout: App
      },
      component: About
    },
    {
      path: "/:locale/category",
      name: "category",
      meta: {
        layout: App
      },
      component: Category
    },
    {
      path: "/:locale/projects",
      name: "projects",
      meta: {
        layout: App
      },
      component: Projects
    },
    {
      path: "/:locale/news",
      name: "news",
      meta: {
        layout: App
      },
      component: News
    },
    {
      path: "/:locale/new/:id",
      name: "new",
      meta: {
        layout: App
      },
      component: New
    },
    {
      path: "/:locale/references",
      name: "references",
      meta: {
        layout: App
      },
      component: References
    },
    {
      path: "/:locale/category/:id",
      name: "name-category",
      meta: {
        layout: App
      },
      component: Projects
    },
    {
      path: "/:locale/project/:id",
      name: "project",
      meta: {
        layout: App
      },
      component: Project
    },
    {
      path: "/:locale/contacts",
      name: "contacts",
      meta: {
        layout: App
      },
      component: Contacts
    }
  ],
  scrollBehavior() {
    window.scrollTo(0, 0);
  }
});
